module.exports = __webpack_public_path__ + "img/middle-bg.17b74c84.png";